import type { SchemaOptions } from '@crmsy/shared';

export function optionColor(schema: SchemaOptions, property: string, value: string | null): string | undefined {
  if (!value) return undefined;
  return schema[property]?.find((o) => o.name === value)?.color;
}

export function Tag({ schema, property, value, extra }: { schema: SchemaOptions; property: string; value: string | null; extra?: number }) {
  if (!value) return <span className="text-muted">—</span>;
  return (
    <span className="inline-flex max-w-full items-center gap-1">
      <span className="tag" data-color={optionColor(schema, property, value)}>
        {value}
      </span>
      {extra ? <span className="text-[11px] text-muted">+{extra}</span> : null}
    </span>
  );
}
